jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

document.addEventListener("DOMContentLoaded", function() {
  // Obtenemos el botón y el span dentro de él
  const button = document.querySelector('.t4s-product-form__submit');
  const span = button.querySelector('.t4s-btn-atc_text');

  // Verificamos si el span contiene el texto 'Pre-order'
  if (span.textContent.trim() === 'Pre-order') {
    // Si contiene 'Pre-order', deshabilitamos el botón
    button.disabled = true;
  }
});
